import { isDefined } from "csi/utility/coreUtility";
import { Box, FlexColumn, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import css from "./CustomViewOptions.module.css";
import GalleryCustomViewOptionsStore from "./GalleryCustomViewOptionsStore";

const PrintOptionPageHeaders: FunctionComponent = observer(function PrintOptionPageHeaders(props) {
	const {
		galleryDropDownOptions: { groupHeaderStyleOptions },
		selectedGroupHeaderStyle,
		setGroupHeaderStyle,
	} = useCustomViewDialogStore().optionsStore as GalleryCustomViewOptionsStore;

	return (
		<>
			{isDefined(groupHeaderStyleOptions) && isDefined(selectedGroupHeaderStyle) && (
				<Box className={css.container}>
					<FlexColumn className={css.optionLeft}>
						<SingleSelect
							disableClearable
							fullWidth
							labelRes="CustomViewGroupHeaders"
							onChange={setGroupHeaderStyle}
							options={groupHeaderStyleOptions}
							value={selectedGroupHeaderStyle}
						/>
					</FlexColumn>
				</Box>
			)}
		</>
	);
});

export default PrintOptionPageHeaders;